import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=0d9c3b20"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=0d9c3b20&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/listfinder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d9c3b20')) {
      api.createRecord('0d9c3b20', component.options)
    } else {
      api.reload('0d9c3b20', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=0d9c3b20", function () {
      api.rerender('0d9c3b20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/auth/password-reissue/Index.vue"
export default component.exports